import { Map, Home, CreditCard, Send, Cloud, Sparkles, Gem, Globe, Mic, Crosshair, MailPlus } from "lucide-react";
import { Reveal } from "./Reveal";
import { INTEGRATIONS } from "@/data/content";

const ICONS = { Map, Home, CreditCard, Send, Cloud, Sparkles, Gem, Globe, Mic, Crosshair, MailPlus };

export const Integrations = () => (
  <section className="py-20 md:py-24 bg-bone border-t border-ink/10" data-testid="integrations-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <p className="text-center text-sm md:text-base text-ink/60 mb-12">
          Best-in-class data + AI, wired together so you don&apos;t have to.
        </p>
      </Reveal>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
        {INTEGRATIONS.map((it, i) => {
          const Icon = ICONS[it.icon];
          return (
            <Reveal key={it.name} delay={(i % 4) * 0.06}>
              <div className="bg-bone flex items-center justify-center gap-3 py-8 group">
                <Icon className="w-5 h-5 text-ink/50 group-hover:text-coral transition-colors duration-300" />
                <span className="text-sm font-medium text-ink/60 group-hover:text-ink transition-colors duration-300 tracking-wide">
                  {it.name}
                </span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
